import generateCalendarLink from './generate-calendar-link'

const initCalendarButtons = (wrapperEl) => {
  return new Promise((resolve, reject) => {
    const buttons = wrapperEl.querySelectorAll('.bhub-calendar-button')

    if (!buttons.length) {
      reject()
      return
    }

    buttons.forEach((button) => {
      const args = button.getAttribute('data-args')
      generateCalendarLink(button, JSON.parse(args))
      resolve()
    })
  })
}

export default initCalendarButtons
